import { CLIENT_TYPES, languages } from "constants/constants";
import { Lang } from "types";

export interface PopupTranslatesParams {
	name: string;
	image: string;
	language: string;
	link?: string;
	actionType?: string;
}

export interface Popup {
	id: number;
	order: number;
	status: number;
	createdAt?: string;
	createdBy?: number;
	updatedAt?: string;
	updatedBy?: number;
	clientType?: string;
	imageUrl?: string;
	popupTranslates?: PopupTranslatesParams[];
}

export interface PopupQueryParams {
	skip: number;
	take: number;
	name?: string | null;
	status?: number | null;
	language: Lang;
	clientType?: string | null;
}

export const initialPopupVal = {
	id: 0,
	order: 0,
	clientType: CLIENT_TYPES.CUSTOMER,
	link: "",
	status: 1,
	popupTranslates: languages.map(val => ({
		name: "",
		language: val.key,
		image: "",
	})),
};
